import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import ChatbotUI from "./ChatbotUI";
import { VscSearch } from "react-icons/vsc";
import { FaArrowLeft } from "react-icons/fa";
import chatImg from "../../assets/img/no chat img.webp";
import botone from "../../assets/img/BOT NO 1.png";
import bottwo from "../../assets/img/BOT NO 2.jpg";
import botthree from "../../assets/img/BOT NO 3.png";
import botfour from "../../assets/img/BOT NO 4.png";
import botfive from "../../assets/img/BOT NO 5.png";
import { useSelector, useDispatch } from "react-redux";
import { fetchConversationsAction } from "../../store/conversation/conversationThunk";
import { markMessageReadAction } from "../../store/lead/leadThunk";
import { useLocation } from "react-router-dom";

export default function ChatTable({ color }) {
  const [selectedChat, setSelectedChat] = useState(null);
  const { leads } = useSelector((state) => state.leads);
  const { conversations } = useSelector((state) => state.conversations);
  const dispatch = useDispatch();
  const location = useLocation();
  const [searchQuery, setSearchQuery] = useState("");
  const [messages, setMessages] = useState({});
  const chatListRef = useRef(null);

  const avatars = [botone, bottwo, botthree, botfour, botfive];

  console.log(leads, "leads");

  const filteredLeads = leads.filter(
    (lead) =>
      lead.Name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      lead.Worker.toLowerCase().includes(searchQuery.toLowerCase())
  );

  // Auto-open chat when navigating from leads page
  useEffect(() => {
    if (location.state?.selectedLead && location.state?.autoOpenChat && leads.length > 0) {
      const { selectedLead } = location.state;
      
      // Find the lead in the current leads list
      const leadToSelect = leads.find(lead => 
        lead.LeadAssignmentId === selectedLead.LeadAssignmentId
      );
      
      if (leadToSelect) {
        setSelectedChat(leadToSelect);
        if (leadToSelect.chatId) {
          dispatch(
            fetchConversationsAction({ chatId: leadToSelect.chatId })
          );
        }

        // Mark messages as read if chat has unread messages
        if (leadToSelect.chatId && leadToSelect.conversation && leadToSelect.conversation.history) {
          const hasUnreadMessages = leadToSelect.conversation.history.some(
            message => message.type === "User" && message.read === false
          );
          
          if (hasUnreadMessages) {
            dispatch(
              markMessageReadAction({
                conversation_id: leadToSelect.chatId,
                onSuccess: () => {
                  console.log("Auto-opened chat: Messages marked as read");
                },
                onError: (error) => {
                  console.error("Error marking messages as read:", error);
                },
              })
            );
          }
        }
        
        // Scroll to the selected chat after a short delay to ensure DOM is updated
        setTimeout(() => {
          const selectedChatElement = document.querySelector(`[data-lead-id="${leadToSelect.LeadAssignmentId}"]`);
          if (selectedChatElement && chatListRef.current) {
            selectedChatElement.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            });
          }
        }, 100);
      }
      
      // Clear the navigation state to prevent re-triggering
      window.history.replaceState({}, document.title);
    }
  }, [location.state, leads, dispatch]);

  const handleBack = () => {
    setSelectedChat(null);
  };

  const handleChatSelect = (chat) => {
    setSelectedChat(chat);
    if (chat.chatId) {
      dispatch(
        fetchConversationsAction({ chatId: chat.chatId })
      );
    }

    // Mark messages as read if chat has unread messages
    if (chat.chatId && chat.conversation && chat.conversation.history) {
      const hasUnreadMessages = chat.conversation.history.some(
        message => message.type === "User" && message.read === false
      );
      
      if (hasUnreadMessages) {
        dispatch(
          markMessageReadAction({
            conversation_id: chat.chatId,
            onSuccess: () => {
              console.log("Messages marked as read");
              // Optionally refresh the leads to update the UI
              // This will happen automatically when the user navigates back to leads
            },
            onError: (error) => {
              console.error("Error marking messages as read:", error);
            },
          })
        );
      }
    }
  };

  useEffect(() => {
    let interval;
    if (selectedChat && selectedChat.chatId) {
      console.log(selectedChat.chatId, "selectedChat chatId");
      interval = setInterval(() => {
        dispatch(
          fetchConversationsAction({
            chatId: selectedChat.chatId,
          })
        );
      }, 10000);
    }

    return () => clearInterval(interval);
  }, [selectedChat, dispatch]);

  useEffect(() => {
    if (selectedChat && selectedChat.chatId) {
      const chatMessages = conversations[selectedChat.chatId];
      console.log(conversations, "message");
      console.log(chatMessages, "Chat messages");

      if (chatMessages && Array.isArray(chatMessages)) {
        // Process the nested structure correctly
        const formattedMessages = chatMessages.flatMap((campaign) => {
          if (campaign.history && campaign.history.details) {
            return campaign.history.details.map((historyItem) => ({
              type: historyItem.Type === "User" ? "user" : "AI",
              content: historyItem.Message,
              timestamp: historyItem.Timestamp,
              name: historyItem.Name
            }));
          }
          return [];
        });

        setMessages((prevMessages) => ({
          ...prevMessages,
          [selectedChat.chatId]: formattedMessages,
        }));
      } else {
        console.error(`Expected an array but got: ${typeof chatMessages}`);
      }
    }
  }, [conversations, selectedChat]);

  const handleSendMessage = (chatId, newMessage) => {
    setMessages((prevMessages) => ({
      ...prevMessages,
      [chatId]: [...(prevMessages[chatId] || []), newMessage],
    }));
  };

  return (
    <div className="relative flex flex-col break-words  w-full mb-6 shadow-lg rounded parent_chat_card">
      <div className="flex p-4  card_table_main">
        <div
          className={`left_side_main_div bg-white shadow-lg rounded-xl p-4 main_chat_module md:w-[500px] ${
            selectedChat && "hidden sm:block"
          }`}
        >
          <h2 className="text-lg font-semibold mb-4">All Messages</h2>
          <div className="mb-4 flex items-center relative input_styles">
            <input
              type="text"
              placeholder="Search here..."
              className="w-full p-2 rounded input_styles"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
            <VscSearch
              size={20}
              className="text-zinc-400 mr-1 absolute right-0"
            />
          </div>
          <div className="overflow-y-auto max-h-72 custom-scrollbar" ref={chatListRef}>
            {filteredLeads.map((lead) => {
              const isSelected = selectedChat?.LeadAssignmentId === lead.LeadAssignmentId;
              
              return (
                <div
                  key={lead.LeadAssignmentId}
                  data-lead-id={lead.LeadAssignmentId}
                  className={`flex items-center p-3 border-b border-gray-200 cursor-pointer transition-all duration-200 ${
                    isSelected 
                      ? "bg-blue-50 border-l-4 border-l-blue-500 shadow-sm" 
                      : "hover:bg-gray-100"
                  }`}
                  onClick={() => handleChatSelect(lead)}
                >
                  <img
                    src={avatars[lead.LeadAssignmentId % avatars.length]}
                    alt="User"
                    className={`w-10 h-10 rounded-full mr-3 ${
                      isSelected ? "ring-2 ring-blue-300" : ""
                    }`}
                  />
                  <div className="flex flex-col w-full">
                    <div className="flex justify-between items-center">
                      <span className={`font-semibold transition-colors duration-200 ${
                        isSelected 
                          ? "text-blue-600" 
                          : "text-orange-500 hover:text-red-500"
                      }`}>
                        {lead?.Name}
                      </span>
                      {/* {isSelected && (
                        <div className="flex items-center">
                          <div className="w-2 h-2 bg-blue-500 rounded-full animate-pulse"></div>
                          <span className="ml-2 text-xs text-blue-600 font-medium">Active</span>
                        </div>
                      )} */}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        <div className="pl-4 h-fit w-full hidden md:block">
          {selectedChat ? (
            <ChatbotUI
              username={selectedChat.Name}
              avatar={avatars[selectedChat.LeadAssignmentId % avatars.length]}
              messages={messages[selectedChat.chatId] || []}
              onSendMessage={(message) =>
                handleSendMessage(selectedChat.chatId, message)
              }
              selectedChat={selectedChat} // Pass selectedChat as a prop
            />
          ) : (
            <div className="flex flex-col items-center justify-center h-full">
              <div className="image-overlay">
                <img
                  src={chatImg}
                  alt="Default Avatar"
                  className="w-20 h-20 mb-4 transparent-img"
                />
              </div>
              <p className="text-gray-600">
                Please select any chat to start conversation
              </p>
            </div>
          )}
        </div>
      </div>
      {/* Third Div - Chat UI for Mobile */}
      <div
        className={`${
          selectedChat ? "block" : "hidden"
        } absolute inset-0 z-50 bg-white p-4 md:hidden w-full`}
      >
        {selectedChat && (
          <>
            <FaArrowLeft
              size={40}
              className="pb-4 cursor-pointer"
              onClick={handleBack}
            />
            <ChatbotUI
              username={selectedChat.Name}
              avatar={avatars[selectedChat.LeadAssignmentId % avatars.length]}
              messages={messages[selectedChat.chatId] || []}
              onSendMessage={(message) =>
                handleSendMessage(selectedChat.chatId, message)
              }
              selectedChat={selectedChat} // Pass selectedChat as a prop
            />
          </>
        )}
      </div>
    </div>
  );
}

ChatTable.defaultProps = {
  color: "light",
};

ChatTable.propTypes = {
  color: PropTypes.oneOf(["light", "dark"]),
};
